import { render, staticRenderFns } from "./fuwu.vue?vue&type=template&id=dbcef85a&scoped=true&"
import script from "./fuwu.vue?vue&type=script&lang=js&"
export * from "./fuwu.vue?vue&type=script&lang=js&"
import style0 from "./fuwu.vue?vue&type=style&index=0&id=dbcef85a&prod&scoped=true&lang=css&"
import style1 from "./fuwu.vue?vue&type=style&index=1&id=dbcef85a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcef85a",
  null
  
)

export default component.exports